import { useBackendApi} from './backendApi';
import { SetupArea, SetupAreaVersionStatus } from './setupAreas';
import { useEventsPublisher } from 'event-bus';
import { MARKETS_UPDATED } from './marketsAdminService';

export function useSetupAreasAdminService() {

  const backendApi = useBackendApi();

  const eventsPublisher = useEventsPublisher();

  const setVersionStatus = async (areaId: number, version: string, status: SetupAreaVersionStatus) => {
    await backendApi.put(`/manager/setupareas/${areaId}/${version}/status`, { status });
  }

  const setVersionName = async (areaId: number, version: string, name: string) => {
    await backendApi.put(`/manager/setupareas/${areaId}/${version}/name`, {
      version: name
    });

    eventsPublisher.publish(MARKETS_UPDATED, {});
  }

  const getSetupAreas = async () => {
    return await backendApi.get('/manager/setupareas') as SetupArea[];
  }

  const getSetupAreaById = async (setupAreaId: number) => {
    return await backendApi.get(`/manager/setupareas/${setupAreaId}`) as SetupArea;
  }

  return {
    setVersionStatus,
    setVersionName,
    getSetupAreas,
    getSetupAreaById,
  }
}
